// extracted by mini-css-extract-plugin
export default {"wrapper":"UserMenu_wrapper__tGWPh","username":"UserMenu_username__IB45y","logout_button":"UserMenu_logout_button__HGt4T"};